export const Constants = {
  Default: "Default",
  ClientOnboardingData: "Client Onboarding Data",
  Equity: "Equity",
  Cash: "Cash",
  OwnPage: "Own Page",
  Actionable: "Today's Actionable",
  ClientStatus: "Client Status",
  Yearly: "Yearly",
  Quarterly: "Quarterly",
  Monthly: "Monthly",
  Weekly: "Weekly",
  New_Client_Creation: "New Client Creation",
  Demat: "Demat",
  TotalClients: "Total Clients",
  NewClients: "New Clients",
  Submitted: "Leads",
  OnboardingData: "Onboarding Data",
  Onboarded: "Onboarded",
  Pending: "Pending",
  Created: "Created",
  Completed: "Completed",
  Created_Client: "Created Client",
  Rejected: "Rejected",
  Rejected_Onboarding: "Rejected Onboarding",
  NotInterested: "Not Interested",
  Raise_Issue: "Raise Issue",
  No_Data: "No Data Available",
  Client_Wise_AUM_Report: "Client Wise AUM Report ",
  Client_Wise_Revenue_Report: "Client Wise Revenue  Report ",
  BusinessSnapshot: "Business Snapshot",
  Figure_In_Lacs: "Figures in Lacs & showing for Current Month",
  Figure_In_Lacs_for_all: "(Figures in Lacs)",
  Amount_In_Lacs: "(All Amount in Lacs)",
  Yesterday: "Yesterday",
  Overall: "Overall",
  Compare_Day: "(Compared with Immediate Previous Day)",
  Change: "Change",
  Previous: "Previous",
  Change_Perc: "Change %",
  Current_Week: "Current Week",
  Compare_Yesterday: "(Compare with previous market day)",
  Compare_Week: "(Compared with Previous Week)",
  Current_Month: "Current Month",
  Compare_Month: "(Compared with Previous Month)",
  Current_Year: "Current Year",
  Compare_Year: "(Compared with Previous Year)",
  Newly_Acquired_Clients: "Newly Acquired Clients",
  Traded_Client: "Traded Client :",
  MarginW: "W/Margin",
  MarginWO: "w/o Margin",
  Inactive_Clients: "Inactive Clients",
  Zero_OP_Clients: "Total Count",
  Thirty_Days: "30 Days",
  Sixty_Days: "60 Days",
  Ninty_Days: "90 Days",
  Top_Broking_Clients: "Top Broking Clients",
  Fifty_Thousand: "15K",
  Ten_Thousand: "10K",
  Five_Thousand: "5K",
  One_Thousand: "1K",
  Top_Clients_MTF: "Top Clients MTF",
  Mtf_Client: "MTF Client",
  Ranking: "Ranking",
  Name: "Name",
  Rank: "Rank",
  Kyc_Application_Submitted:
    "Number of Applications submitted but client code not generated.",
  Revenue_Times: "Revenue Times",
  Margin_Txt: "Total Margin",
  Location: "Location",
  Client_List: "Client List",
  Quick_Links: "Quick Links",
  Knowledge_Centre: "Knowledge Centre",
  Help_Guide: "Help Guide",
  Top_Active_Clients: "Top Active Clients",
  Client_ID: "Client ID",
  Brokerage: "Brokerage",
  YTD_Brokerage: "YTD Brokerage",
  Past_Average: "Past Average",
  Overall_PnL: "Overall P&L",
  Lifetime_Income: "Lifetime Brokerage",
  Top_Inactive_Clients: "Top Inactive Clients",
  No_Birthday: "No Birthday Today",
  Wish: "Wish ",
  Birthday_Wish:
    "May your birthday be the start of a year filled with good luck, good health and much happiness.",
  Send_Greetings: "Send Greetings",
  Happy_Birthday: "Happy Birthday",
  Mail_Sent: "Mail sent successfully",
  Rms_Alert: "RMS Alert",
  Summary_Reactivation: "Summary for Reactivation",
  HNI: "HNI",
  Retail: "Retail",
  Clients_Reactivation: "Total Clients Reactivation",
  Inactive: "Total Inactive",
  Clients_Inactive_Duration:
    "Clients inactive for 6 months (Includes auto-send)",
  Client_Services: "Client in Services",
  Moderately_Active: "Moderately Active",
  Client_Inactive_For_3and6:
    "Clients inactive for {" >
    "} 3 but {" >
    "} 6 months Average renvenue is Rs. 2000.00",
  Client_Handover: "Client Handover",
  Semi_Active: "Semi Active",
  Average_revenue: "Average renvenue is Rs. 2000.00 past 3 months",
  Total: "Total",
  Five_Hundred: "500",
  Eighty_Five_percent: "85%",
  Others: "Others",

  Client_Reactivation: "All your other clients given for reactivation",
  Total_Reactivation: "Total Clients Reactivation",
  Active: "Active",
  New: "New",
  Filter: "Filter",
  Filters: "Filters",
  PAN: "PAN Number",
  Date_Range: "Create Date Range",
  Updated_Date_Range: "Updated Date Range",
  OnBoarding_Date: "On-Boarding Date Range",
  KYC_Status: "KYC Status",
  Unable_Connect: "Unable to Connect",
  Verified: "Verified",
  Not_Verified: "Not-Verified",
  Comments: "Comments",
  One: "One",
  Two: "Two",
  Three: "Three",
  Calling_Status: "Calling Status",
  Lead_Status: "Lead Status",
  Assignee: "Assignee",
  Source: "Source",
  Select_Source: "Select Source",
  Ekyc: "Ekyc",
  Samadhan: "Samadhan",
  Device: "Device",
  Select_Device: "Select Device",
  Referral_ID: "Referral ID",
  Is_Referred: "Is Referred",
  Select_Is_Referred: "Select Is Referred",
  Yes: "Yes",
  No: "No",
  Screen_Identifier: "Screen Identifier",
  Select_Screen_Identifier: "Select Screen Identifier",
  Stock_Segmentation: "Stock Segmentation",
  Revenue: "Revenue",
  Future_Options: "Future & Options",
  Brokerage_Summary: "Brokerage Summary",
  Projected_Shortfall: "Projected Shortfall",
  Projected_Brokerage: "Projected Brokerage",
  IPO_Details: "IPO Details",
  Product_Type: "Product Type :",
  Hierarchy_Report: "Hierarchy Report",
  Report_As_Per: "Report as per",
  Single_Holding_Report: "Single holding Report",
  Asset_Type: "Asset Type :",
  Script_Scheme_Instrument: "Script/Scheme/Instrument :",
  Sub_Product_Type: "SubProduct Type :",
  Company_Name: "IPO Name",
  Number_Subscription: "Subscriptions",
  Lots_Subscribed: "Lot Allotted",
  Research: "Research",
  Today_Client_Info: "Today's Client Info",
  Quarterly_Settlement: "Quarterly Settlement",
  Ageing_Debt: "Ageing Debit",
  Ageing_Debt_Tone: "T + 1",
  Ageing_Debt_Ttwo: "T + 2",
  Ageing_Debt_Tthree: "T + 3",
  Naked_Debit: "Naked Debit",
  Portfolio_Gainers: "Portfolio Overview (Top 5 Gainers )",
  Portfolio_Loosers: "Portfolio Overview (Top 5 Loosers )",
  Portfolio_Value_Cost: "Portfolio Value Cost",
  Portfolio_Value: "Portfolio Value (Market)",
  Total_Gain_Loss: "Total Gain/ Loss",
  Gain_Loss_percent: "Gain/ Loss %",
  Overview: "Overview",
  Details: "Details",
  Reports: "Reports",
  My_Net_Worth: "My Net Worth",
  As_On: "as on",
  Stocks: "Stocks",
  Net_Worth: "Net Worth",
  Investments: "Investments",
  Liabilities: "Liabilities",
  Coming_Soon: "Coming Soon",
  Equity_Portfolio_Analysis: "Portfolio Health",
  Net_Equity_Portfolio: "Net Equity Portfolio",
  Holdings: "Holdings",
  Positions: "Positions",
  Portfolio_Growth: "Portfolio Growth",
  Inc_Portfolio_Years: "Portfolio Trend",
  Portfolio: "Portfolio",
  KYC: "KYC",
  Client_since: "Client since ",
  Referred_By: "Referred By",
  Sales_Employee_Code: "Sales Employee Code",
  Lead_Source: "Lead Source",
  Basic_Details: "Basic Details",
  Full_Name: "FULL NAME",
  NAME_AS_IT_SITE: "NAME AS PER IT SITE",
  gender: "gender",
  FATHER_NAME: "FATHER’S NAME",
  Mother_Name: "Mother's Name",
  DATE_OF_BIRTH: "DATE OF BIRTH",
  MARITAL_STATUS: "MARITAL STATUS",
  NOMINEE: "NOMINEE",
  Address_Details: "Address Details",
  ADDRESS_LINE_1: "ADDRESS LINE 1",
  CITY: "CITY",
  ADDRESS_LINE_2: "ADDRESS LINE 2",
  STATE: "STATE",
  ADDRESS_SAME: "ARE BOTH ADDRESS SAME?",
  ZIP_CODE: "ZIP CODE",
  CORRESPONDENCE_ADD_1: "CORRESPONDENCE ADDRESS LINE 1",
  CORRESPONDENCE_CITY: "CORRESPONDENCE CITY",
  CORRESPONDENCE_ADDRESS_2: "CORRESPONDENCE ADDRESS LINE 2",
  CORRESPONDENCE_STATE: "CORRESPONDENCE STATE",
  CORRESPONDENCE_ZIP: "CORRESPONDENCE ZIP CODE",
  Bank_Details: "Bank Details",
  BANK_NAME: "BANK NAME",
  BRANCH: "BRANCH",
  BANK_ZIPCODE: "BANK ZIPCODE",
  ACCOUNT_NUMBER: "ACCOUNT NUMBER",
  IFSC_CODE: "IFSC CODE",
  MICR_NUMBER: "MICR NUMBER",
  ACCOUNT_TYPE: "ACCOUNT TYPE",
  CANCELLED_CHEQUE_FILE: "CANCELLED CHEQUE FILE",
  PENNY_BENEFICIARY_NAME: "PENNY BENEFICIARY NAME",
  Fatca: "Fatca",
  BIRTH_PLACE: "BIRTH PLACE",
  POLITICAL_RELATION: "POLITICAL RELATION",
  ITAX_COUNTRY: "ITAX COUNTRY",
  BIRTH_COUNTRY: "BIRTH COUNTRY",
  INCOME_SLAB: "INCOME SLAB",
  OCCUPATION_CODE: "OCCUPATION CODE",
  TAX_ID_NUMBER: "TAX ID NUMBER",
  User_Uploaded_Documents: "User Uploaded Documents",
  ADDRESS_PROOF_FRONT: "ADDRESS PROOF FRONT",
  ADDRESS_PROOF_REAR: "ADDRESS PROOF REAR",
  ADDRESS_PROOF_TYPE: "ADDRESS PROOF TYPE",
  PAN_CARD_FILE: "PAN CARD FILE",
  INV_PHOTO_FILE: "INV PHOTO FILE",
  GEO_LOCATION: "INV PHOTO GEO LOCATION",
  INV_SIGN_FILE: "INV SIGN FILE",
  INV_SIGN_FILE_FORMAT: "INV SIGN FILE FORMAT",
  INCOME_PROOF_FILE: "INCOME PROOF FILE",
  INCOME_PROOF_TYPE: "INCOME PROOF TYPE",
  POA_FILE: "POA FILE",
  CHEQUE_FILE: "CHEQUE FILE",
  IDENTIFIER_NUMBER: "IDENTIFIER NUMBER",
  EXPIRY_DATE: "EXPIRY DATE",
  IPV_FILE: "IPV FILE",
  Income_Details: "Income Details",
  TAX_COUNTRY: "TAX COUNTRY",
  EXPERIENCE: "EXPERIENCE",
  INCOME_DATE: "INCOME DATE",
  INCOME_TYPE: "INCOME TYPE",
  OCCUPATION: "OCCUPATION",
  POLITICS: "POLITICS",
  QUALIFICATION: "QUALIFICATION",
  IPV_Details: "IPV Details",
  IPV_NAME: "IPV NAME",
  IPV_EMPLOYEE_CODE: "IPV EMPLOYEE CODE",
  IPV_OTP: "IPV OTP",
  IPV_FACEMATCH: "IPV FACEMATCH",
  IPV_LOCATION: "IPV LOCATION",
  CREATED_DATE: "CREATED DATE",
  MODIFIED_DATE: "MODIFIED DATE",
  Forms: "Forms",
  AOF_FILE: "AOF FILE",
  CKYC: "CKYC",
  CLIENT_REGISTRATION_FILE: "CLIENT REGISTRATION FILE",
  COMMODITY_REGISTRATION_FILE: "COMMODITY REGISTRATION FILE",
  EQUITY_CODE: "EQUITY CODE",
  COMMODITY_CODE: "COMMODITY CODE",
  Backoffice_Uploads: "Backoffice Uploads",
  KRA_PAGE_FILE: "KRA PAGE FILE",
  KRA_ADDRESS_PROOF_FILE: "KRA ADDRESS PROOF FILE",
  KRA_PAN_FILE: "KRA PAN FILE",
  BO_INCOME_FILE: "BO INCOME FILE",
  PAN_IT_FILE: "PAN IT FILE",
  EXTRA_DOCUMENT_FILE: "EXTRA DOCUMENT FILE",
  Aadhaar_Documents: "Aadhaar Documents",
  AADHAAR_PHOTO: "AADHAAR PHOTO",
  Nominee_Details: "Nominee Details",
  NOMINEE_NAME: "NOMINEE NAME",
  NOMINEE_RELATION: "NOMINEE RELATION",
  ONBOARD_STATUS: "ONBOARD STATUS",
  AUTH_ONBOARD_STATUS: "AUTH ONBOARD STATUS",
  APPROVAL_STATUS: "APPROVAL STATUS",
  ESIGN_STATUS: "ESIGN STATUS",
  EKYC_SUBMITTED_STATUS: "E-KYC SUBMITTED STATUS",
  ESIGN_CONSENT: "ESIGN CONSENT",
  ESIGN_CONSENT_TS: "ESIGN CONSENT TS",
  IP_ADDRESS: "IP ADDRESS",
  DEVICE_ID: "DEVICE ID",
  KYC_VERIFIED: "KYC VERIFIED",
  AADHAAR_VERIFIED: "AADHAAR VERIFIED",
  CREATED_AT: "CREATED AT",
  ONBOARDED_AT: "ONBOARDED AT",
  UPDATED_AT: "UPDATED AT",
  UPDATED_BY: "UPDATED BY",
  NRI: "NRI",
  KRA_AGENT: "KRA AGENT",
  Support: "Support",
  Tickets_Overview: "Tickets Overview",
  Tickets_Raised: "Tickets Raised",
  Tickets_Resolved: "Tickets Resolved",
  Tickets_Pending: "Tickets Pending",
  Tickets_Close: "Tickets Close",
  Satisfaction_Survey: "Satisfaction Survey",
  Status: "Status",
  Date: "Date",
  Active_Inactive_Session: "Active / Inactive Session",
  Last_Logged_In: "Last Logged In",
  Monthly_Avg_Usage: "Monthly Avg. Usage",
  Mutual_Fund: "Mutual Fund",
  FandO: "F&O",
  Holding_Statement: "Client holding Report",
  As_On_Date: "As On Date",
  Generate: "Generate",
  Submit: "Submit",
  Excel: "Excel",
  PDF: "PDF",
  Isin: "ISIN",
  Scrip_Code: "Scrip Code",
  BSE_code: "BSE code",
  POA_hold: "POA hold",
  Margin_Pledge: "Margin Pledge",
  Exchange_Pledge: "Exchange Pledge",
  MTF_Pledge: "MTF Pledge",
  MTF_Coll_Pledge: "MTF Coll Pledge",
  BFL_Pledge: "BFL Pledge",
  Unpaid: "Unpaid",
  Unsettle: "Unsettle",
  Total_Holding: "Total Holding",
  Holding_report_not_exist: "Holding report does not exist.",
  Client_holding_report_msg: "Client holding report does not exist.",
  Select_correct_date: "Please Select Correct Date.",
  Financial_Ledger_Report: "Financial Ledger Report",
  From: "From",
  To: "To",
  Exchange: "Exchange",
  Voucher_Date: "Voucher Date",
  Effective_Date: "Effective Date",
  Voucher_Type: "Voucher Type",
  Voucher_No: "Voucher No",
  Narration: "Narration",
  Debit: "Debit",
  Credit: "Credit",
  Balance: "Balance",
  Ledger_Report_doesnt_exist: "Ledger report does not exist.",
  MTF_Details_Report: "MTF Details Report",
  Bal_Date: "Bal Date",
  Running_Bal: "Running Bal",
  Int_Per: "Int Per",
  Int_Amount: "Int Amount",
  MTF_Details_Report_doesnt_exist: "MTF Details Report does not exist.",
  Pnl_Report: "P&L Report",
  Scrip_Name: "Scrip Name",
  Net_Quantity: "Net Quantity",
  Average_Price: "Average Price",
  Investment_Val: "Investment Val",
  Current_Price: "Current Price",
  Current_Val: "Current Val",
  Unreleased_gain_Loss: "Unrealized P&L",
  Unreleased: "Unrealized(%)",
  Released_gain_Loss: "Realized P&L",
  Released: "Realized(%)",
  Total_PNL_Amount: "Total P&L",
  Symbol: "Symbol",
  Instrument_Type: "Instrument Type",
  Option_Type: "Option Type",
  Expiry_Date: "Expiry Date",
  Strike_Price: "Strike Price",
  Buy_Price: "Buy Price",
  Buy_Quantity: "Buy Quantity",
  Sell_Price: "Sell Price",
  Sell_Quantity: "Sell Quantity",
  Unrealised_Gain_Loss: "Unrealized Gain/Loss",
  Realised_Gain_Loss: "Realized Gain/Loss",
  Pnl_report_doesnt_exist: "Pnl report does not exist.",
  Tax_Report: "Tax Report",
  Intraday_Tax: "Intraday Tax",
  Intraday_GL: "Intraday G/L",
  Short_Term_Tax: "Short Term Tax",
  Short_Term_GL: "Short Term G/L",
  Long_Term_Tax: "Long Term Tax",
  Long_Term_GL: "Long Term G/L",
  Equity_Fund_Short_Term: "Equity Fund Short Term",
  Equity_Fund_Short_Term_GL: "Equity Fund Short Term G/L",
  Equity_Fund_Long_Term: "Equity Fund Long Term",
  Equity_Fund_Long_Term_GL: "Equity Fund Long Term G/L",
  Non_Equity_Fund_Short_Term: "Non Equity Fund Short Term",
  Non_Equity_Fund_Short_Term_GL: "Non Equity Fund Short Term G/L",
  Non_Equity_Fund_Long_Term: "Non Equity Fund Long Term",
  Non_Equity_Fund_Long_Term_GL: "Non Equity Fund Long Term G/L",
  Tax_Report_doesnt_exist: "Tax Report does not exist.",
  Get_Contract_List_Report: "Contract List Report",
  Contract_Name: "Contract Name",
  User_Friendly_Name: "User Friendly Name",
  Max_Contract_Note_Period: "Max Contract Note Period",
  Client_Code: "Client Code",
  Get_Contract_List_doesnt_exist: "Contract List Report does not exist.",
  Combine_Ledger_Report: "Combine Ledger Report",
  Combine_Ledger_Doesnt_exist: "Combine Ledger Report Does not exist.",
  Dividend_Report: "Dividend Report",
  Stock_Name: "Stock Name",
  Dividend_Date: "Dividend Date",
  Dividend_Type: "Dividend Type",
  Dividend_Per_Share: "Dividend Per Share",
  Qty_Dividend_Date: "Qty As On Dividend Date",
  Dividend_Amount: "Dividend Amount",
  Dividend_Report_doesnt_exist: "Dividend Report does not exist.",
  DP_Report: "DP Report",
  Bill: "Bill",
  Transaction: "Transaction",
  Txn_Date: "Txn Date",
  Trans_No: "Trans No",
  Instrument: "Instrument",
  Charges_Details: "Charges Details",
  Opening_Qty: "Opening Qty",
  Credit_Qty: "Credit Qty",
  Debit_Qty: "Debit Qty",
  Balance_Qty: "Balance Qty",
  Charges: "Charges",
  Taxes: "Taxes",
  Total_Charges: "Total Charges",
  Quantity: "Quantity",
  DP_Report_doesnt_exist: "DP Report does not exist.",
  MTF_Delay_Payment_Report: "MTF Delay Payment Report",
  Dpc_Date: "Dpc Date",
  Dpc_Balance_Charges: "Dpc Balance Charges",
  Debit_Int: "Debit Int",
  Net_Dpc_Charges: "Net Dpc Charges",
  From_Date: "From Date",
  To_Date: "To Date",
  MTF_DelayPayment_doesnt_exist: "MTF Delay Payment Report does not exist.",
  Morning_Limit_Report: "Morning Limit Report",
  Toatal_Ledger: "Total Ledger",
  Total_Coll_Value: "Total Coll Value",
  Margin_Utilization_Fno: "Margin Utilization Fno",
  Available_Limit: "Available Limit",
  Broking_Ledger: "Broking Ledger",
  Broking_Stock_Value: "Broking Stock Value",
  Total_Margin_Utilization: "Total Margin Utilization",
  Excess_Shortfall: "Excess Shortfall",
  MTF_Sanction: "MTF Sanction",
  MTF_Ledger: "MTF Ledger",
  MTF_Funded: "MTF Funded",
  MTF_Market: "MTF Market",
  MTF_Coll_Value: "MTF Coll Value",
  MTF_Shortfall: "MTF Shortfall",
  MTF_Sanctioned_Limit: "MTF Sanctioned Limit",
  Morning_Limit_doesnt_exist: "Morning Limit Report does not exist.",
  Trade_Summary_Report: "Trade Summary Report",
  Action: "Action",
  Market_Rate: "Market Rate",
  Txn_Value: "Txn Value",
  Net_Rate: "Net Rate",
  STT: "STT",
  Service_Tax: "Service Tax",
  Trade_summary_doesnt_exist: "Trade summary report does not exist.",
  LTCG_Report: "LTCG Report",
  Close_Price: "Close Price",
  Total_Quantity: "Total Quantity",
  Trade_Date: "Trade Date",
  Days_Left: "Days Left",
  Current_Value: "Current Value",
  Unrealized_Profit: "Unrealized Profit",
  Short_Term_Tax: "Short Term Tax",
  Long_Term_Tax: "Long Term Tax",
  Ltcg_Report_dosnt_exist: "LTCG Report does not exist.",
  failed_To_Fetch: "Failed to fetch LTCG Report.",
  Levies_Report: "Levies Report",
  Scrip: "Scrip",
  Sauda_Date: "Sauda Date",
  Gst: "GST",
  Stamp_Duty: "Stamp Duty",
  Sebi_Tax: "Sebi Tax",
  Turn_Tax: "Turn Tax",
  Other_Charges: "Other Charges",
  Total_Charges: "Total Charges",
  Levies_Report_doesnt_exist: "Levies Report does not exist.",
  Dashboard: "Dashboard",
  Onboarding: "Onboarding",
  Client_Name: "Client Name:",
  From_Date: "From Date:",
  To_Date: "To Date:",
  Search: "Search",
  Client_Search: "Client Search:",
  All_fields_Mandatory: "All the fields are Mandatory.",
  EQ: "EQ",
  MF: "MF",
  Type: "Type:",
  Client_Ids: "Client Id's",
  Debit_Amount: "Debit Amount",
  Sign_out: "Sign out",
  Settings: "Settings",
  Change_Account_settings: "Change your profile and account settings.",
  Change_Password: "Change Password",
  Set_new_Password: "Set new Password",
  Dark_Theme: "Dark Theme",
  Denotes_combination_light: "Denotes the combination of light",
  Dividend_Info: "Dividend Info",
  Total_Companies: "Total Companies",
  Total_Shares: "Total Shares",
  Total_Dividend: "Total Dividend",
  Coming_Soon: "Coming Soon...",
  Stock_Symbol: "Stock Symbol",
  Total_Qty: "Total Qty.",
  Avg_Cost_Price: "Avg. Cost Price",
  LTP: "LTP",
  Invested_Value: "Invested Value",
  pnl_value: "P&L Value",
  pnl_percent: "P&L %",
  Invested_Amount: "Invested Amount",
  Profit_Loss: "Profit / Loss",
  Open_IPOs: "Open IPO’s",
  Subscribed: "Subscribed",
  Number_Lots: "No. of Lots",
  Margin_details: "MTF Details",
  Last_Traded_Price: "Last Traded Price",
  Haircut_Rate: "Haircut Rate",
  Margin_Provided: "Margin Provided",
  Payin_Payout_Details: "Payin & Payout Details",
  Platform_Wise_Info: "Platform Wise Info",
  Risk_Profile: "Risk Profile",
  Trading_Transactions: "Trading Transactions",
  Traded_Type: "Traded Type",
  Buy_Qty: "Buy Qty",
  Buy_Avg_Rate: "Buy Avg Rate",
  Buy_Amount: "Buy Amount",
  Sell_Qty: "Sell Qty",
  Sell_Avg_Rate: "Sell Avg Rate",
  Sell_Amount: "Sell Amount",
  Net_Qty: "Net Qty",
  Net_Avg_Rate: "Net Avg Rate",
  Net_Amount: "Net Amount",
  Write_to_Us: "Write to Us",
  Client_Name_Code: "Client Name /Code",
  Alternate_No: "Alternate No.",
  Message: "Message",
  Attachment: "Attachment",
  Client_Summary: "Client Summary",
  Summary_Client: "Summary",
  Available_For_Trading: "Available For Trading",
  Future_Bill_Cr_Dr: "Future Bill Cr. / Dr.",
  Margin_Utilised: "Margin Utilised",
  Ledger_Balalnce: "Ledger Balance",
  Today_Balance: "Today's Balance",
  Today_Pay_in: "Today's Pay-in",
  Today_Payout: "Today's Payout",
  RM_Mapping: "Rm Mapping",
  AP_Master: "AP Master",
  Charges: "Charges",
  Delayed_Payment_Charges: "Delayed Payment Charges",
  DP_Charges: "DP Charges",
  Margin_Against_Assets: "Margin Against Assets",
  Early_Payin: "Early Payin ",
  Margin_Against_Holdings: "Margin Against Holdings",
  Cfs: "CFS",
  DP_no: "DP ID",
  Last_Traded_Date: "Last Traded Date",
  Primary_Bank: "Primary Bank",
  Account_no: "Account No",
  Dealer_Name_Code: "Dealer Name/Code",
  RM_Name_Code: "RM Name/Code",
  Branch_Name_Code: "Branch Name/Code",
  Segments: "Segments",
  client_holding_statement_not_exist: "Client Holding Statement Does Not Exist",
  Analytics: "Analytics",
  Largecap: "Largecap",
  Smallcap: "Smallcap",
  Midcap: "Midcap",
  Investment_Snapshot: "Investment Snapshot",
  IPO_Info: "IPO Info",
  Reach_Us: "Reach Us",
  contact_No: "020 3957 4151",
  // Email_Id: "customercare@BFSL.com",
  Email_Id: "franchisesupport@bajajfinserv.in",
  Office: "The Office",
  address: "Bajaj Financial Securities Limited",
  Full_Address:
    "Bajaj Financial Securities LimitedUnit-9&10, Tower-B, 1st Floor, Mantri IT Park, Nagar Road, Viman Nagar, Pune-411014.",
  Business_Hours: "Business Hours",
  Working_Hrs: "Monday - Friday: 9am - 6:30pm",
  Working_Saturday: "Saturday: 10am - 4pm",
  Immediate_Previous_Date: "(Compared with Immediate Previous Day)",
  Change_Password_Bajaj: "Change Password - Bajaj Finserv",
  OLD_PASSWORD: "OLD PASSWORD",
  NEW_PASSWORD: "NEW PASSWORD",
  CONFIRM_NEW_PASSWORD: "CONFIRM NEW PASSWORD",
  Password_changed:
    "Your password has been changed successfully. For next login use this password.",
  Enter_Correct_Password: "Please enter correct old password.",
  Recover_UserId: "Recover UserId - Bajaj Finserv",
  Recover_Id: "Recover User ID",
  UserId_Sent_On_Email: "Your User ID will be sent to your Email",
  EMAIL: "Email",
  Back_Login: "Back to Login?",
  Faild_mail: "Faild to sent mail",
  Copyright_Bajaj:
    "Copyright Bajaj Broking. All rights reserved. SEBI Registration No : INZ000218931",
  Forget_Password: "Forget Password - Bajaj Finserv",
  Forgot_Pass: "Forgot Password?",
  Password_Reset_Link: "Password Reset Link Will be Send to your Email",
  USER_ID: "USER ID",
  Login_BFSL: "Login to Bajaj Broking",
  Welcome_Back: "Welcome back! Please enter your details.",
  Forgot_UserID: "Forgot User ID?",
  PASSWORD: "PASSWORD",
  Log_In: "Log In",
  Membership_Details: "Membership Details",
  mail_to: "connect@bajajfinserv.in",
  mobile_No: "18008338888",
  Create_Account: "Create an Account",
  Enter_details: "Welcome! Please enter your details.",
  NAME: "NAME",
  Mobile: "Mobile No",
  MOBILE_NUMBER: "MOBILE NUMBER",
  Sign_Up: "Sign Up",
  Already_have_account: "Already have an account?",
  Login: "Login",
  Page_Not_Found: "Page Not Found",
  Requested_page_notFound:
    "We're sorry ,the page you requested could not be found",
  Go_Back: "Go Back",
  Holding_Report: "Client Holding Statement Report",
  PnL_Report: "PnL Report",
  Payin_Detail: "Payin Detail",
  Payout_Detail: "Payout Detail",
  Date_and_Time: "Date and Time",
  Amount: "Amount",
  Payment_Mode: "Payment Mode",
  Bank_Account: "Bank Account",
  Transaction_Id: "Transaction Id",
  Reference_No: "Reference No",
  Revenue_Snapshot: "Revenue Snapshot",
  Brok_Del: "Brok Del",
  Brok_Trd: "Brok Trd",
  client_Name: "Client Name",
  Holding_Value: "Holding Value",
  Total_Holdings: "Total Holdings",
  AUM_Snapshot: "AUM Snapshot",
  View_All: "View All",
  Debt: "Debt",
  view_allocation: "View allocation % By",
  Sector: "Sector",
  Market_Cap: "Market Cap",
  Knowledge_Center: "Knowledge Center",
  FAQ: "FAQ's",
  Client_Brokerage: "Client Brokerage",
  Transaction_Type: "Transaction Type",
  Brokerage_Rate: "Brokerage Rate %",
  Equity_Cash: "Equity Cash",
  Intraday: "Intraday (Per Order)",
  Delivery: "Delivery (Per Order)",
  Futures: "Futures (Per Order)",
  Options: "Options (Per Order)",
  Equity_Fno: "Equity F&O",
  Tentative_Margin_Report: "Tentative Margin Report",
  Margin_Report: "Margin Shortage Report",
  Initial_Margin: "Initial Margin",
  Extreme_Loss: "Extreme Loss Margin (ELM)",
  MTM_Margin: "MTM Margin",
  Final_Settlement: "Final settlement Margin",
  Additional_Margin: "Additional Margin",
  EOD_Total_Margin: "EOD Total Margin Amount",
  Peak_Margin: "Peak Margin Amount",
  EOD_Total_Margin_Member: "EOD Total Margin Reported by Member",
  Peak_Margin_Member: "Peak Margin Reported by Member",
  EOD_Shortfall: "EOD Shortfall",
  Peak_Shortfall: "Peak Shortfall",
  Branche_Code: "Branche Code",
  Segment: "Segment",
  Rm_Name: "RM Name",
  Rm_Email: "RM Email",
  Attention_Required: "Attention Required",
  As_Per_Regulatory_Account_Suspended:
    " As per the regulatory requirement, you are requested to update the Income range and Income proof for your account. Failure to provide/update Income range and Income proof may lead to your account getting suspended.",
  Call_For_Any_Documents:
    "I understand that BFSL reserves the right to call for any further document/clarification/information including seeking of details/information from any third party relating to income declared by me.",
  Select_Your_Income_Range: " Select Your Income Range",
  Declaration: "Declaration",
  I_Agree: "I Agree",
  List_Of_Income_Not_Updated: "List of Income Proof not updated",
  Update: "Update",
  Below1Lac: "Below 1 Lakh",
  OneTo5: "1 - 5 Lakh",
  FiveTo10: "5 - 10 Lakh",
  TenTo25: "10 - 25 Lakh",
  MoreThan25: "More than 25 Lakh",
  Statement_Demat_Holdings: "Statement of Demat Holdings.",
  Statement_last_6_Months: "Bank account Statement for last 6 Months.",
  Latest_Salary_Slip: "Latest Salary Slip.",
  Copy_Of_ITR_Acknowledgement: "Copy of ITR acknowledgement.",
  Copy_Form_16_salary: "Copy of form 16 in case of salary income.",
  Net_Worth_Certificate: "Net-worth Certificate.",
  Upload_Your_Income_Proof: "Upload your income proof",
};
